import { globalTheme } from "../../styles";

export const UnShippedIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = globalTheme.blue } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <path style={{ fill: fill, stroke: "#888888" }} d="M 92,25 92,82 59,99 9,82 10,25 59,36 z" />
      <path style={{ fill: fill, stroke: "#222222", strokeWidth: 1 }} d="M 10,25 1,10 38,4 47,18 53,3 98,8 92,25 59,36 z" />
      <path style={{ fill: fill, stroke: "#222222", strokeWidth: 1 }} d="M 10,25 47,18 92,25 59,36 z" />
      <path style={{ fill: fill, stroke: "#444444", strokeWidth: 1.5 }} d="m 59,38 0,59" />
      <path style={{ fill: fill, stroke: "none" }} d="M 1,41 10,25 59,36 92,25 99,42 66,55 59,36 51,56 z" />
    </svg>
  );
};
